<automatic-debit-breadcrumb [items]="breadcrumbItems"></automatic-debit-breadcrumb>

<div class="file-page-selected mt-5">
    <!-- Card do Arquivo Importado -->
    <div class="card shadow-sm">
        <div class="card-header bg-file-header text-white d-flex justify-content-between align-items-center">
            <h5 class="mb-0"><i class="bi bi-file-earmark-text"></i> {{ fileSelected?.header?.identification }}</h5>

            <h4 class="float-right">{{ fileSelected?.header?.institutionName }}</h4>
            <h4 class="float-right">Nº {{ fileSelected?.header?.sequentialNsa }}</h4>
            <span> Versão {{ fileSelected?.header?.versionFile }}</span>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <button (click)="downloadFile(fileSelected)" class="btn btn-primary btn-sm float-right">
                        <i class="flaticon-download-1 text-white"></i>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <strong>Arquivo: </strong>
                    <span>{{ fileSelected?.fileName }}</span>
                </div>
                <div class="col-md-2">
                    <strong>Convênio : </strong>
                    <span>{{ fileSelected?.header?.agreementCode }}</span>
                </div>
                <div class="col-md-3">
                    <strong>Banco : </strong>
                    <span>{{ fileSelected?.header?.bankCode }} - {{ fileSelected?.header?.bankName }}</span>
                </div>

                <div class="col-md-3">
                    <strong>Total do Arquivo :</strong>
                    <span class="text-success total-file-value"> R$ {{ totalFile | currency }}</span>
                </div>
            </div>

            <div class="row">
                <div class="col-md-2">
                    <strong>Cod. Registro : </strong>
                    <span>{{ fileSelected?.header?.registryCode }}</span>
                </div>
                <div class="col-md-3">
                    <strong>Importado por : </strong>
                    <span>{{ fileSelected?.userName }}</span>
                </div>
                <div class="col-md-3">
                    <strong>Data de importação : </strong>
                    <span>{{ fileSelected?.header?.generateDate | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="col-md-3">
                    <strong>Data de Recebimento : </strong>
                    <span class="text-success total-file-value">
                        {{ dataReceivingList[0]?.dateReceiving | date: 'dd/MM/yyyy' }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- Tabela de Boletos -->
    <div class="card shadow-sm mt-3">
        <div class="card-header bg-secondary-2 d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Boletos Encontrados</h5>

            <div class="status-arquivo">
                <label class="mb-0">
                    Status do arquivo
                    <span (click)="refreshStatusFile()" class="fa fa-sync text-sucess pointer"></span>
                </label>
                <h3 class="text-success">{{ fileSelected?.statusFileName }}</h3>
            </div>
            <div class="col-md-2 flex-center">
                <label>Mês para contabilizar:</label>
                <input type="date" class="form-control" [(ngModel)]="dateAccountingStr"  />
            </div>
            <div class="float-right">
                <button [disabled]="enableBtnProcess" (click)="btnProcessFile()" class="btn btn-success">
                    Processar Arquivo
                    <span class="ml-3 fa fa-check"></span>
                </button>
                <button [disabled]="!enableBtnProcess" (click)="btnAccountingFile()" class="ml-3 btn btn-primary">
                    Contabilizar
                    <span class="ml-3 fa fa-check-square"></span>
                </button>
            </div>
        </div>

        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead class="bg-light">
                    <tr>
                        <th>#</th>
                        <th>Entidade</th>
                        <th>Número</th>
                        <th>Aluno</th>
                        <th>Vencimento</th>
                        <th>Valor</th>
                        <th>Desconto</th>
                        <th>TotalRecebido</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let dataReceiving of dataReceivingList; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ dataReceiving?.entityName }}</td>
                        <td>{{ dataReceiving?.billetNumber }}</td>
                        <td>{{ dataReceiving?.personName }}</td>
                        <td>{{ dataReceiving?.lineDate | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ dataReceiving?.billetValue | currency }}</td>
                        <td>{{ dataReceiving?.discountValue | currency }}</td>
                        <td>{{ dataReceiving?.receivedValue | currency }}</td>
                        <td>
                            <div class="status-area">
                                {{ dataReceiving?.returnCodeDescription }}
                                <div class="false-received">
                                    <div *ngIf="dataReceiving?.returnCode != 0">
                                        <span
                                            *ngIf="dataReceiving.isPendency"
                                            class="fa fa-exclamation-triangle text-warning">
                                        </span>
                                        <span
                                            *ngIf="!dataReceiving.isPendency"
                                            class="fa fa-exclamation-triangle text-success">
                                        </span>
                                    </div>
                                </div>

                                <div *ngIf="dataReceiving?.received" class="true-received">
                                    <span class="ml-3 fa fa-check text-success"> </span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex">
                                <button (click)="goToBillet(dataReceiving?.billetId)" class="btn btn-sm btn-primary">
                                    <span class="fa fa-home"></span>
                                </button>

                                <select
                                    *ngIf="showButtonReceiving(dataReceiving) || (dataReceiving?.returnCode != 0 && dataReceiving.isPendency)"
                                    class="form-control form-control-sm ml-3"
                                    style="width: 100px;"
                                    (change)="returnSelect({typeSolution: $event.target.value, element: dataReceiving}); $event.target.value = '0'"
                                    [value]="0">
                                    <option value="0" disabled>Ações</option>
                                    <option *ngIf="showButtonReceiving(dataReceiving)" value="1">Receber</option>
                                    <option *ngIf="showButtonReceiving(dataReceiving)" value="2">Receber outro boleto</option>
                                    <option *ngIf="dataReceiving?.returnCode != 0 && dataReceiving.isPendency" value="3">Resolver</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Modal Component -->
<file-modal-billets
    [showHide]="openbilletsFromResponsible"
    (resShowHide)="openbilletsFromResponsible = $event"
    (clearClose)="onReturnElement($event)">
</file-modal-billets>
